import { forwardRef, type SVGProps } from 'react';

export interface EraserIconProps extends Omit<SVGProps<SVGSVGElement>, 'css'> {}

export const EraserIcon = forwardRef<SVGSVGElement, EraserIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 16 16">
    <path
      d="M4.64651 5.64645C4.84177 5.45118 5.15828 5.45118 5.35354 5.64645L11.1035 11.3964C11.2988 11.5917 11.2988 11.9082 11.1035 12.1035C10.9083 12.2987 10.5918 12.2987 10.3965 12.1035L4.64651 6.35348C4.45125 6.15822 4.45125 5.84171 4.64651 5.64645Z"
      fill="currentColor"
    />
    <path
      d="M8.4097 1.9393C9.19076 1.15826 10.4573 1.15826 11.2383 1.9393L14.774 5.47445C15.555 6.25548 15.5549 7.522 14.774 8.30307L8.72318 14.3538C8.6294 14.4476 8.5018 14.5003 8.36917 14.5003L3.50003 14.4998C3.36746 14.4998 3.24027 14.4471 3.14652 14.3534L0.985386 12.1922C0.204353 11.4112 0.204316 10.1446 0.985386 9.36361L8.4097 1.9393ZM10.5313 2.64633C10.1407 2.2558 9.50727 2.2558 9.11673 2.64633L1.69242 10.0711C1.30199 10.4616 1.3019 11.0947 1.69242 11.4852L3.70707 13.4998H8.16214L14.0669 7.59603C14.4573 7.20556 14.4572 6.57249 14.0669 6.18197L10.5313 2.64633Z"
      fill="currentColor"
    />
    <path
      d="M14.5 13.5C14.7761 13.5 15 13.7239 15 14C15 14.2761 14.7761 14.5 14.5 14.5H7.5C7.22386 14.5 7 14.2761 7 14C7 13.7239 7.22386 13.5 7.5 13.5H14.5Z"
      fill="currentColor"
    />
  </svg>
));

EraserIcon.displayName = 'EraserIcon';
